













import './KisweToggleButton.scss'
import { defineComponent } from '@vue/composition-api'
import { RadioButton, RadioGroup } from 'element-ui'
import { KisweToggleButtonOption } from '../../types'
import { useSizes } from '../../compositions'

export default defineComponent({
  name: 'KisweToggleButton',
  components: {
    'el-radio-button': RadioButton,
    'el-radio-group': RadioGroup
  },
  props: {
    value: {
      type: String,
      required: true
    },
    options: {
      type: Array as () => KisweToggleButtonOption[],
      required: true
    },
    ...useSizes().props
  },
  methods: {
    onChange (value: string) {
      this.$emit('input', value)
    }
  }
})
